var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompleted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0C22.4 0 0 22.4 0 50C0 77.6 22.4 100 50 100C77.6 100 100 77.6 100 50C100 22.4 77.6 0 50 0ZM50 90C27.95 90 10 72.05 10 50C10 27.95 27.95 10 50 10C72.05 10 90 27.95 90 50C90 72.05 72.05 90 50 90ZM69.4 31.45L40 60.85L30.6 51.45C29.6651 50.5151 28.3971 49.9899 27.075 49.9899C25.7529 49.9899 24.4849 50.5151 23.55 51.45C22.6151 52.3849 22.0899 53.6529 22.0899 54.975C22.0899 56.2971 22.6151 57.5651 23.55 58.5L36.5 71.45C38.45 73.4 41.6 73.4 43.55 71.45L76.5 38.5C76.9635 38.0374 77.3312 37.488 77.5822 36.8831C77.8331 36.2783 77.9622 35.6298 77.9622 34.975C77.9622 34.3202 77.8331 33.6717 77.5822 33.0669C77.3312 32.462 76.9635 31.9126 76.5 31.45C74.55 29.5 71.35 29.5 69.4 31.45Z",
    fill: "#27AE60"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.8dbcfc8bd36225bc38a4ec3820c73639.svg";
export { ForwardRef as ReactComponent };